import { Button } from '@bbl-digital/snorre-v2'

type Props = {
  text?: string
} & React.ComponentProps<typeof Button>

const FileuploadPickerButton = ({ text = 'Last opp fil', ...props }: Props) => {
  return <Button {...props}>{text}</Button>
}

export default FileuploadPickerButton
